import * as actions from 'actions';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case actions.COMMENTS_FETCH_SUCCESS:  // We are getting older comments
      return action.isForLiveList && action.result.commentsIds.length == 0;

    case actions.COMMENTS_RESET_LIVE_LIST:
      return false;

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/live/endReached/reducer.js
 **/